import * as React from 'react'
import Milliseconds from '../../helper/milliseconds'

interface Props {
    message?: {
        args: {
            queries: {
                [query: string]: {
                    ct: number
                    wt: number
                }
            }
        }
    }
}

export default class Sql extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        if (!message) {
            return <div>We observed Traces with slow SQL calls.</div>
        }

        const { args } = message

        return (
            <div>
                <p>This trace shows slow or repeated SQL calls:</p>

                <ul>
                    {Object.entries(args.queries).map(([call, stats]) => (
                        <li key={call}>
                            <code>{call}</code> was executed {stats.ct} times and took <Milliseconds value={stats.wt} />.
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
}
